<template>
  <div>
    <h6>
      {{ question.label }} {{ question.required ? '*' : '' }}
    </h6>
    <div class="mb-2" v-html="question.description"></div>
    <b-form-group>
      <b-form-input
        :size="size"
        type="number"
        :step="step"
        v-model="answer"
        :name="question.slug"
        :required="question.required"
        :state="!!errors ? false : null"
        :placeholder="question.placeholder"
        :min="question.options.mininum"
        :max="question.options.maximum"
        @focus="$emit('clear-error', question.slug)"
      />
      <b-form-invalid-feedback :state="!!errors ? false : null">
        {{ (errors||[]).join(' ') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
  function intOrNull(value) {
    if (value === undefined ||
      value === null ||
      value === '' ||
      typeof value == 'string' && value.trim() === '' ||
      isNaN(value))
      return null
    return parseInt(value, 10)
  }
  function floatOrNull(value) {
    if (value === undefined ||
      value === null ||
      value === '' ||
      typeof value == 'string' && value.trim() === '' ||
      isNaN(value))
      return null
    return parseFloat(value)
  }

  export default {
    props: {
      value: Number, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
    },
    data() {
      return {
        trans: trans,
        answer: this.value === undefined ?
          this.question.options.default :
          (this.question.options.decimal_places ? floatOrNull(this.value) : intOrNull(this.value)),
      }
    },
    computed: {
      step() {
        if (this.question.options.decimal_places == 1) return 0.1
        if (this.question.options.decimal_places == 2) return 0.01
        if (this.question.options.decimal_places == 3) return 0.001
        if (this.question.options.decimal_places == 4) return 0.0001
        if (this.question.options.decimal_places == 5) return 0.00001
        if (this.question.options.decimal_places == 6) return 0.000001
        return 1
      },
    },
    watch: {
      answer() {
        let answer = this.question.options.decimal_places ? floatOrNull(this.answer) : intOrNull(this.answer)
        if (this.value !== answer) this.$emit('input', answer)
      },
      value() {
        this.answer = this.value === undefined ?
          this.question.options.default :
          (this.question.options.decimal_places ? floatOrNull(this.value) : intOrNull(this.value))
      },
      question() {
        this.answer = this.value === undefined ?
          this.question.options.default :
          (this.question.options.decimal_places ? floatOrNull(this.value) : intOrNull(this.value))
      },
    },
    mounted() {
      window['questionNumber'+this.question.id] = this
    },
  }
</script>